
import useAxios from "../utils/useAxios";
import { useState, useEffect } from "react";

export function useAgencies() {
  const [agencies, setAgencies] = useState([]);
  const [loading, setLoading] = useState(true);

   const axiosAPI = useAxios()

  useEffect(() => {
    async function fetchAgencies() {
      try {
        const response = await axiosAPI.get("/api/dashboard/get-all-agencies");
        setAgencies(response.data.data);
      } catch (error) {
        console.error("Error fetching agencies:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchAgencies();
  }, []);

  return { agencies, loading };
}
